/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  ButtonBase,
  IconButton,
  Menu,
  MenuItem,
  Typography
} from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import React, { useEffect, useState } from 'react'

import { User, UserBrief } from '../../types/users'
import UserRow from './UserRow'
import UserRowMobile from './UserRowMobile'
import UserRowMobileSkeleton from './UserRowMobile.skeleton'
import useStyles from './styles/UsersTable.styles'

interface UsersTableMobileProps {
  userData: UserBrief[]
  loading: boolean
  refetch: () => void
}
const UsersTableMobile: React.FC<UsersTableMobileProps> = ({
  userData,
  loading,
  refetch
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.tableHeadMobile}>
        <div>
          <Typography variant="body1">Name</Typography>
        </div>
        <div className={classes.refreshButtonContainer}>
          <IconButton
            onClick={() => {
              refetch()
            }}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </div>
      </div>
      {loading
        ? Array(5)
            .fill('')
            .map((item, index) => <UserRowMobileSkeleton key={index} />)
        : userData.map((item) => <UserRowMobile key={item.ID} data={item} />)}
    </div>
  )
}

export default UsersTableMobile
